// import { Message } from 'element-ui'
let socket = null
let isConnect = false
export async function doConnect() {
  return new Promise((resolve, reject) => {
    if (isConnect) {
      resolve(true)
    } else {
      socket = new WebSocket('ws://127.0.0.1:13888')
      const timeoutId = setTimeout(() => {
        socket.close()
        reject(new Error('WebSocket connection timed out'))
      }, 5000)
      socket.onopen = () => {
        clearTimeout(timeoutId)
        isConnect = true
        console.log('WebSocket connection success', event)
        socket.onmessage = (event) => {
          console.log('Client received a message', event)
        }
        socket.onclose = (event) => {
          console.log('Client notified socket has closed', event)
          isConnect = false
        }
        resolve(true)
      }
      socket.onerror = (error) => {
        clearTimeout(timeoutId)
        console.log('Client notified socket has onerror', error)
        reject({ error, errorMessage: '抖音打印控件链接失败，请下载并打开《抖店官方打印组件》' })
      }
    }
  })
}

export const sendMessage = (request) => {
  try {
    socket.send(JSON.stringify(request))
  } catch (error) {
    console.log(error)
  }
}
export const getConnectStatus = () => isConnect
